import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/contexts/AuthContext";
import { ApiError } from "@/lib/api/client";
import { courseGuideApi, type CourseGuide } from "@/lib/api/courseGuide";
import type { Read } from "@/components/ui/box.schema";

export function useGuide(course: string, preparation: boolean, enabled = true) {
  const { me } = useAuth();
  return useQuery({ queryKey: ["course-guide", me?.tenant_id, me?.user_id, course, preparation],
    queryFn: () => courseGuideApi.read(course, preparation), retry: false, enabled: enabled && !!course });
}
export function guideRead(query: ReturnType<typeof useGuide>): Read<CourseGuide> {
  if (query.error instanceof ApiError && [401, 403, 404].includes(query.error.status)) return { status: "forbidden" };
  if (!query.data) return query.isError ? { status: "failed", sentence: "The guide could not be read.", retry: () => void query.refetch() } : { status: "loading" };
  if (query.isError) return { status: "stale", last: query.data, readAt: query.data.read_at, sentence: "The guide could not be refreshed.", refresh: () => void query.refetch() };
  return { status: "ready", value: query.data, readAt: query.data.read_at };
}
